import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, setToken, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import { SignalBars } from "../components/common";

export default function InvitePage() {
  const { token } = useParams();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const { setTheme, networkName } = useTheme();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/invite/${token}`)
      .then((r) => {
        setInfo(r.data);
        if (r.data.resolved) setTheme(r.data.resolved);
        setForm((f) => ({ ...f, name: r.data.character_name || "" }));
      })
      .catch((e) => setErr(errMsg(e)));
  }, [token, setTheme]);

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const r = await api.post(`/invite/${token}/accept`, form);
      setToken(r.data.access_token);
      setUser(r.data.user);
      nav("/play", { replace: true });
    } catch (ex) {
      setErr(errMsg(ex));
      setBusy(false);
    }
  }

  return (
    <div className="h-full w-full flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 30%, color-mix(in srgb, var(--r-primary) 10%, transparent), rgba(7,9,13,0.96) 70%)" }} />
      <div className="relative z-10 w-full" style={{ maxWidth: 400 }}>
        <div className="frame glow-primary p-7 fade-up" style={{ background: "rgba(13,17,23,0.94)" }}>
          <div className="flex items-center justify-between mb-3">
            <SignalBars />
            <span className="sys-label">INVITATION · NODE</span>
          </div>
          <h1 className="font-title font-black text-2xl tracking-tight text-glow">{networkName}</h1>
          {err && !info ? (
            <div className="font-mono text-xs mt-6 py-2 px-3" style={{ color: "var(--r-alert)", border: "1px solid var(--r-alert)" }}>✕ {err}</div>
          ) : info ? (
            <>
              <p className="sys-label mt-2">ACCÈS AUTORISÉ</p>
              <div className="mt-4 mb-4 p-3 frame">
                <div className="sys-label">IDENTITÉ</div>
                <div className="font-title font-bold text-lg">{info.character_name}</div>
                <div className="sys-label mt-1" style={{ textTransform: "none", letterSpacing: "normal" }}>{info.campaign_name}</div>
              </div>
              <form onSubmit={submit} className="space-y-3">
                <div>
                  <span className="sys-label block mb-1.5">IDENTIFIANT (EMAIL)</span>
                  <input data-testid="invite-email" className="input font-mono" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="vous@exemple.com" />
                </div>
                <div>
                  <span className="sys-label block mb-1.5">MOT DE PASSE</span>
                  <input data-testid="invite-password" type="password" className="input font-mono" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="••••••••" />
                </div>
                {err && <div className="font-mono text-xs py-2 px-3" style={{ color: "var(--r-alert)", border: "1px solid var(--r-alert)" }}>✕ {err}</div>}
                <button data-testid="invite-submit" disabled={busy} className="btn btn-solid w-full">{busy ? "CONNEXION…" : "ACTIVER L'ACCÈS"}</button>
              </form>
            </>
          ) : (
            <div className="sys-label mt-6 blink">CHARGEMENT…</div>
          )}
        </div>
      </div>
    </div>
  );
}
